import React, { useState } from "react";
import {
Box,
Card,
Typography,
Button,
TextField,
Alert,
CircularProgress,
InputAdornment,
IconButton
} from "@mui/material";

import PasswordStrengthBar from "../components/PasswordStrengthBar";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Colors } from "../utils/colors";
import { useNavigate, useLocation } from "react-router-dom";
import { API } from "../constant/apiConstant";
import {
getResetToken,
INVALID_RESET_LINK_MESSAGE,
isStrongPassword,
PASSWORD_REQUIREMENTS_MESSAGE
} from "../utils/passwordReset";

const ResetPassword = () => {

const navigate = useNavigate()
const location = useLocation()

const email = location.state?.email || ""
const resetToken = getResetToken(location)

const [password,setPassword] = useState("")
const [confirmPassword,setConfirmPassword] = useState("")
const [loading,setLoading] = useState(false)
const [showPassword,setShowPassword] = useState(false)
const [showConfirmPassword,setShowConfirmPassword] = useState(false)

const [alert,setAlert] = useState({
show:false,
type:"info",
message:""
})

const showAlert=(type,message,time=5000)=>{

setAlert({
show:true,
type,
message
})

setTimeout(()=>{
setAlert(prev=>({...prev,show:false}))
},time)

}




const resetPassword = async () => {

if(!resetToken){
showAlert("error",INVALID_RESET_LINK_MESSAGE)
return
}

if(!isStrongPassword(password)){
showAlert("error",PASSWORD_REQUIREMENTS_MESSAGE)
return
}

if(password !== confirmPassword){

showAlert("error","Passwords do not match")
return

}

setLoading(true)

try{

const res = await fetch(`${API.BASE_URL}/api/auth/reset-password`,{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({
reset_token:resetToken,
password
})
})

const data = await res.json()

if(!data.status){

showAlert("error",data.message || "Unable to reset password")
setLoading(false)
return

}

showAlert("success","Password reset successfully. Please log in with your new password.",3000)

setTimeout(()=>{
navigate("/login")
},3000)

}catch(error){

showAlert("error","Unable to connect to server")

}

setLoading(false)

}


return(

<Box
sx={{
minHeight:"50vh",
p:3,
display:"flex",
justifyContent:"center",
alignItems:"center"
}}
>

<Card sx={{p:4,borderRadius:1,width:"100%",maxWidth:500}}>

<Typography
variant="h5"
sx={{color:Colors.accent}}
fontWeight={700}
>
Reset Password
</Typography>

{alert.show && (
<Alert severity={alert.type} sx={{mt:2}}>
{alert.message}
</Alert>
)}

{!resetToken && (
<Alert severity="error" sx={{mt:2}}>
{INVALID_RESET_LINK_MESSAGE}
</Alert>
)}

<TextField
label="Email Address"
fullWidth
sx={inputStyle}
value={email}
disabled
/>

<TextField
label="New Password"
type={showPassword ? "text" : "password"}
fullWidth
sx={inputStyle}
value={password}
onChange={(e)=>setPassword(e.target.value)}
error={!!password && !isStrongPassword(password)}
helperText={password && !isStrongPassword(password) ? PASSWORD_REQUIREMENTS_MESSAGE : ""}
InputProps={{
endAdornment: (
<InputAdornment position="end">
<IconButton
onClick={()=>setShowPassword((prev)=>!prev)}
edge="end"
sx={{color:"white"}}
aria-label={showPassword ? "Hide new password" : "Show new password"}
>
{showPassword ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
</IconButton>
</InputAdornment>
)
}}
/>

<PasswordStrengthBar password={password} />

<TextField
label="Confirm Password"
type={showConfirmPassword ? "text" : "password"}
fullWidth
sx={inputStyle}
value={confirmPassword}
onChange={(e)=>setConfirmPassword(e.target.value)}
InputProps={{
endAdornment: (
<InputAdornment position="end">
<IconButton
onClick={()=>setShowConfirmPassword((prev)=>!prev)}
edge="end"
sx={{color:"white"}}
aria-label={showConfirmPassword ? "Hide confirm password" : "Show confirm password"}
>
{showConfirmPassword ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
</IconButton>
</InputAdornment>
)
}}
/>

<Typography
sx={{
mt:1,
textAlign:"right",
fontSize:13,
color:Colors.accent,
cursor:"pointer",
fontWeight:600
}}
onClick={()=>navigate("/forgot-password")}
>
Forgot Password?
</Typography>

<Button
fullWidth
variant="contained"
sx={{mt:3,backgroundColor:Colors.secondary,color:"white"}}
onClick={resetPassword}
disabled={
!resetToken ||
!isStrongPassword(password) ||
password !== confirmPassword ||
loading
}
>

{loading
? <CircularProgress size={24} sx={{color:"white"}}/>
: "Reset Password"
}

</Button>

<Typography
sx={{
mt:2,
textAlign:"center",
color:Colors.muted,
fontSize:14
}}
>

Remember your password?{" "}
<span
style={{
color:Colors.accent,
cursor:"pointer",
textDecoration:"underline",
fontWeight:600
}}
onClick={()=>navigate("/login")}
>
Login
</span>

</Typography>

</Card>

</Box>

)

}


const inputStyle={
mt:2,
"& .MuiOutlinedInput-root":{
"& fieldset":{borderColor:Colors.accent},
"&:hover fieldset":{borderColor:Colors.accent},
"&.Mui-focused fieldset":{borderColor:Colors.accent}
},
"& .MuiInputLabel-root":{
color:Colors.accent
},
"& .MuiInputLabel-root.Mui-focused":{
color:Colors.accent
},
input:{
color:"whitesmoke"
}
}

export default ResetPassword
